import styled from "styled-components";

export const StyledContainerBodyProfessionalWay = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
`;

export const StyledContainerProfessionalWay = styled.div`
  margin-top: 20px;
`;
